export const cibBuddy = ["32 32","<path d='M28.932 7.078l-11.672-6.74c-0.776-0.453-1.74-0.453-2.521 0l-11.672 6.734c-0.781 0.453-1.26 1.286-1.26 2.187v13.479c0 0.896 0.479 1.729 1.26 2.182l11.672 6.74c0.781 0.448 1.74 0.448 2.521 0l11.677-6.74c0.776-0.453 1.26-1.281 1.26-2.182v-13.479c0-0.901-0.484-1.734-1.26-2.182zM19 17.411l-5.073 5.073-1.802-1.802 5.073-5.073-5.073-5.073 1.802-1.802 6.875 6.875z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-buddy.js
// module id = null
// module chunks = 